export default __webpack_public_path__ + "static/media/Path3476.3bdc1584.svg";